import { Type } from '@sinclair/typebox';
import { ProductAttrValueType } from '@stickerapp-org/nomisma';
// Schema for the response of a single attribute
export const AttributeResponseSchema = Type.Object({
    id: Type.Number(),
    name: Type.String(),
    type: Type.Enum(ProductAttrValueType),
    multivalue: Type.Boolean(),
    dynamicvalue: Type.Boolean(),
    versionId: Type.Number(),
});
// Schema for creating a new attribute
export const CreateAttributeSchema = Type.Omit(AttributeResponseSchema, ['id']);
// Schema for updating an existing attribute
export const UpdateAttributeSchema = Type.Partial(Type.Omit(CreateAttributeSchema, ['versionId']));
//# sourceMappingURL=attributes.js.map